<template>
  <div>
    <div v-if="disabled" v-b-tooltip="{ title: 'One item should be selected' }" class="wheel-no-outline-disabled">
      <mdicon name="CogOutline" class="right" />
    </div>
    <b-dropdown v-else class="wheel-no-outline no-pad" no-caret>
      <template #button-content>
        <mdicon name="CogOutline" class="right" />
      </template>
      <DropdownItem
        v-for="actionItem of actions"
        :key="actionItem.handle"
        :action="actionItem"
        :assignment="assignment"
      />
    </b-dropdown>
  </div>
</template>

<script lang="ts">
import type { Action } from '@/types/Components/Actions'
import type { Assignment } from '@/types/Models/Assignment'
import { BDropdown } from 'bootstrap-vue-next'
import { computed, type ComputedRef, defineComponent } from 'vue'
import {
  sortAction,
  filterAction,
  prepareAction,
  transformAction,
  ItemSettingsConfig,
} from '@/composables/Assignment/useActionHandlers'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useItemStore } from '@/store/item'
import DropdownItem from '@/views/Components/Assignment/Cells/DropdownItem.vue'

export default defineComponent({
  name: 'SettingsButton',
  components: { BDropdown, DropdownItem },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const itemStore = useItemStore()
    const accountStore = useAccountStore()

    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)
    const isStaff: ComputedRef<boolean> = computed(() => accountStore.isStaff)
    const checkedItems: ComputedRef<string[]> = computed(() => itemStore.checkedItems)
    const disabled: ComputedRef<boolean> = computed(() => checkedItems.value.length !== 1)

    const actions: ComputedRef<Action[]> = computed(() =>
      ItemSettingsConfig.map((action: Action) => prepareAction(assignment, isStaff.value)(action))
        .filter(filterAction(assignment))
        .map(transformAction(assignment, isStaff.value))
        .sort(sortAction),
    )

    return {
      actions,
      disabled,
      assignment,
    }
  },
})
</script>
